<template>
  <WorkInProgress />
</template>


<script>
import WorkInProgress from './components/WorkInProgress.vue'

export default {
  name: 'App',
  components: {
    WorkInProgress
  }
}
</script>

<style src="@/assets/css/main.css" lang="css" />